import { api } from 'data/api/api'

export const confirmCancellationAgreement = (transactionId: number) =>
  api.post(`/transactions/${transactionId}/cancellation_agreement/confirm`)
